module.exports = __webpack_public_path__ + "img/start_marker.5ea73040.svg";